<template>
    <main>
        <div class="row mt-2">
            <div class="list-group mb-3 col-lg-4 col-md-12 col-sm-12" v-for="(item) in $v.higiene_oral.$each.$iter" :key="item.id">
                <div class="list-group-item">
                    <div class="d-flex align-items-center justify-content-between">
                        <buttonsCheck 
                            :antecedente="item" 
                            :label="item.$model.descripcion" 
                            :type="item.$model.tipo_campo.codigo"
                            :validator="item"
                            v-model="item.$model.ho_usuario.valor">
                        </buttonsCheck>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>
<script>
import buttonsCheck from '../baseButtonsCkeck/indexButtons';
import higieneOralService from '../../../../services/higieneOralService';
import higieneOralUsuarioService from '../../../../services/higieneOralUsuarioService';
import {required} from "vuelidate/lib/validators";
import { isEmpty } from 'lodash';
import Toast from "../../../../components/common/utilities/toast";

export default {
    props: ['embarazo_actual', 'usuario', 'idHistoria', 'finalizada', 'modo'],
    components: { buttonsCheck },
    data() {
        return {
            type: 'store',
            higiene_oral: []
        }
    },
    validations(){
        return {
            higiene_oral:{
                $each:{
                    ho_usuario:{
                        valor:{required}
                    },
                }
            }
        }
    },
    methods:{
        async save() {
            try {
                this.$v.$touch();
                if(this.$v.$invalid){
                    return;
                }

                let higiene_oral_usuario = [];

                this.higiene_oral.forEach((x) => {
                    if (x.ho_usuario.valor !== "") {
                        higiene_oral_usuario.push({ ...x.ho_usuario });
                    }
                });

                this.LoaderSpinnerShow();
                await higieneOralUsuarioService.store({
                    higiene_oral_usuario: higiene_oral_usuario,
                });
                this.LoaderSpinnerHide();
                Toast.fire({
                    icon: 'success',
                    title: 'Datos guardados con éxito'
                });
            } catch (error) {
                console.log(error);
                this.LoaderSpinnerHide();
                Toast.fire({
                    icon: "error",
                    title: "Ha ocurrido un error al procesar la solicitud",
                });
            }
        },
    },
    async created() {
        const filter = {
            sexo: this.usuario.sexo,
            fecha_nacimiento: this.usuario.fecha_nacimiento,
            ...(!isEmpty(this.embarazo_actual) && this.embarazo_actual.activo === 'S' ? { gestante: 'S' } : {})
        };

        const response = await higieneOralService.index({
            params: filter
        });

        const higiene_oral_usuario = await higieneOralUsuarioService.index(
            this.usuario.id
        );

        this.higiene_oral = response.data.map((y) => {
            const indice = higiene_oral_usuario.data.findIndex(
                (a) => a.id_higiene === y.id
            );
            y.ho_usuario = {
                id: indice !== -1 ? higiene_oral_usuario.data[indice].id : 0,
                id_usuario: this.usuario.id,
                id_higiene: y.id,
                valor: indice !== -1 ? higiene_oral_usuario.data[indice].valor : "",
            };
            return y;
        });
    }

}
</script>